import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import SortableTable from './SortableTable';
import { useNavigate } from 'react-router-dom';

const AdminRoute = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const handleLogin = () => {
    instance.loginPopup(loginRequest)
      .then(response => {
        localStorage.setItem("userInfo", JSON.stringify(response.account));
        localStorage.setItem("loginType", "microsoft"); // ✅ Mark as MSAL login
        navigate("/admin", { replace: true });
      })
      .catch(e => console.error(e));
  };

  // ✅ Only allow MSAL-authenticated users
  if (!isAuthenticated || localStorage.getItem("loginType") !== "microsoft") {
    return (
      <div className="text-center mt-5">
        <h3>You must be logged in with Microsoft to access the admin panel.</h3>
        <button className="submit-button" onClick={handleLogin}>
          Login with Microsoft
        </button>
      </div>
    );
  }

  return <SortableTable />;
};

export default AdminRoute;